// tools.js
import Annotation from './annotation-plugin/annotation';
export var EDITOR_JS_TOOLS = {
  annotation: Annotation
};